import { ColumnSort, SortingState } from '@tanstack/react-table';
import { sort } from 'radash';

import { DataModelAttribute } from '@/types/DataModel';

type GenerateInitialSortingState = (
    collectionAttribute: DataModelAttribute,
    memberAttributes: DataModelAttribute[],
) => SortingState;

export const generateInitialSortingState: GenerateInitialSortingState = (
    collectionAttribute,
    memberAttributes,
) => {

    const sortingOptions = collectionAttribute.params?.uiCollectionSorter;
    const sortingState: (ColumnSort & { priority: number })[] = [];

    if (sortingOptions) {

        memberAttributes.forEach((attribute, index) => {

            const sortingOption = sortingOptions[attribute.name];

            if (sortingOption) {
                const id = attribute.name;
                const sortDescFirst = sortingOption.initialDirection === 'desc';
                const priority = sortingOption.sortPriority || index;

                sortingState.push({
                    id,
                    desc: sortDescFirst,
                    priority,
                });
            }

        });

    }

    return sort(sortingState, state => state.priority);
};
